import { render } from "./GtListPage.vue?vue&type=template&id=2b248d16&scoped=true"
import script from "./GtListPage.vue?vue&type=script&lang=js"
export * from "./GtListPage.vue?vue&type=script&lang=js"

import "./GtListPage.vue?vue&type=style&index=0&id=2b248d16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b248d16"]])

export default __exports__